import React, {Component} from 'react';
import Logo, { LogoSimples } from '../header/logo';
import { HeaderPrincipal } from '../statics/cabecarios';
import Footer from '../statics/footer';
import InfoChat from './info_chat';
import './chat.css'
import MensagensChat from './mensagens_chat';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Chat extends Component{
    constructor(){
        super();
        this.state={convidado:{nome:'Joelma Maia', categoria:'Pequenas empresas'}}
        
    }
    render(){
        return(
            <div id='chat-page'>
                <LogoSimples/>
                <div style={{marginRight:'0', marginBottom:'2%'}} className='container '>
                    <div className='row chat-container'>
                        <InfoChat/>
                        <MensagensChat/>
                    </div>
                    <div className='row' style={{textAlign:'right', flexDirection:'row-reverse', marginRight:'0', marginTop:'15px'}}>
                        <a href='usuario/contratar' role='button' className='btn col-2 btn-custom btn-custom-gray'>Encerrar</a>
                        <div className='contador col-3' style={{textAlign:'center'}}>
                            <FontAwesomeIcon icon={faClock} />
                            <p>00:00</p>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>

        )
    }
}